import React, { useEffect, useState } from "react";
import { collection, getFirestore, getDocs } from "firebase/firestore";
import { app } from "../../Firebase/Firebaseapp";
import InsertAdmin from "./InsertAdmin";

const db = getFirestore(app);

const AddAdmin = () => {
  const [createUserModal, setcreateUserModal] = useState(false);
  const [Adminuser, setAdminuser] = useState([]);
  const getalldata = () => {
    return getDocs(collection(db, "AdminUser"));
  };

  useEffect(() => {
    console.log("add admin");
    getalldata().then((books) => {
      setAdminuser(books.docs);
    });
  }, []);
  console.log(Adminuser);

  return (
    <>
      <div className=" w-[100%]">
      
        <div className="flex flex-col min-h-screen w-[100%]">
          <h2 className="font-semibold text-gray-800 text-2xl text-center w-[100%] mt-[5vh]">
            Admin Users
          </h2>

          <div className="flex justify-center items-center h-[20%] w-[100%]  mt-4">
            <button
              className=" bg-[crimson] h-[50px] w-[320px] rounded text-white"
              onClick={() => setcreateUserModal(true)}
            >
              Add Admin
            </button>
          </div>

          <div className="h-auto w-[100%] flex justify-center  items-center mb-10 mt-4  ">
            <div className="flex justify-center flex-col items-cente h-[100%] w-[95%] lg:w-[70%]">
              <div className="flex justify-center  items-cente h-[80%] w-[100%]  sm:p-7 compare  rounded">
                <table className="table-auto w-[100%]">
                  <thead className="text-xs font-semibold uppercase ">
                    <tr>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">ID</div>
                      </th>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">Name</div>
                      </th>
                      <th className="p-2 whitespace-nowrap">
                        <div className="font-semibold text-left">Email</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm divide-y divide-gray-100">
                    {Adminuser &&
                      Adminuser.map((x, index) => {
                        return (
                          <tr className=" h-[5vh]" key={index}>
                            <td className="p-2 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="font-medium text-gray-800">
                                  {index + 1}
                                </div>
                                <div className="w-10 h-10 flex-shrink-0 mr-2 sm:mr-3">
                                  <img
                                    className="rounded-full"
                                    src="https://i1.pngguru.com/preview/137/834/449/cartoon-cartoon-character-avatar-drawing-film-ecommerce-facial-expression-png-clipart.jpg"
                                    width="40"
                                    height="40"
                                    alt="Alex Shatov"
                                  />
                                </div>
                              </div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div className="text-left">{x.data().name}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div className="text-left font-medium text-green-500">
                                {x.data().email}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {createUserModal == true ? (
          <InsertAdmin setcreateUserModal={setcreateUserModal} />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default AddAdmin;
